<template>
  <div :class="{'reg-watch': isRegWatch, 'reg-filter': !registrationHeader, 'registration-header-reg-filter': registrationHeader}">
    <div :id="registrationHeader ? 'registration-header-activityFilter' : 'activityFilter'">
      <div
        data-toggle="dropdown"
        class="text-right cursor-pointer"
        v-if="collapsed"
        :class="{'hide-field': !collapsed, 'reg-watch': isRegWatch, 'reg-dropdown' : registrationHeader}"
        @click="showHideFilter()"
      >
        <span class="dropdown-toggle cursor vertical-align-middle">
          <img v-if="!registrationHeader" src="/static/images/icons/filter.svg"/>
          <img v-if="registrationHeader" src="/static/images/icons/filter_new.svg" class="compliance_tracker_filter records-filter" />
          <span :class="registrationHeader ? 'registration-header-count' : 'count'" v-if="showFilterIcon">
            <span class="glyphicon glyphicon-ok"></span>
          </span>
          <img v-if="registrationHeader" src="/static/images/icons/filter_right_angle_icon.svg" alt class="chevron-right" @click="setFilterOptions()"/>
        </span>
      </div>
      <div class="dropdown-menu dropdown-menu-left" :class="{'hide-field': collapsed, 'registration-header-filter-ul': registrationHeader, 'filter-ul' : !registrationHeader}">
        <div class="col-xs-12 p-0 filter-card-header">
          <div class="col-xs-12 pb-1 pl-0 pr-0 filter-card-outline">
            <div data-toggle="dropdown" class="col-xs-1 filter-icon p-0">
              <img v-if="!registrationHeader" src="/static/images/icons/filter.svg" class="image-size" />
              <img v-if="registrationHeader" src="/static/images/icons/filter_new.svg" class="compliance_tracker_filter" />
            </div>
            <div class="col-xs-11 filter-text">{{$t('filters')}}</div>
            <div class="col-xs-1 pr-0 pl-0">
              <a @click="showHideFilter(true)">
                <img src="/static/images/icons/filter_right_angle_icon.svg" class="cursor-pointer left-transform cursor" />
              </a>
            </div>
          </div>
          <div class="col-xs-12 reset-apply-buttons">
            <button type="button" class="btn reset-link" v-if="permissions.includes('CLEAR_ALL')" @click="clearAll" :disabled="checkForDisability()">
              {{$t('resetAll')}}
            </button>
            <!-- <button type="button" class="btn apply-btn">
              {{$t('apply')}}
            </button> -->
          </div>
        </div>
        <div class="col-xs-12 filter-wrapper p-0">
          <div v-if="permissions.includes('COLUMN_OPTIONS')" class="col-xs-12 column-options-carret-section p-0 filter-options-outline">
            <div class="filter-options">{{$t('columnOptions')}}</div>
            <span>
              <button data-toggle="collapse" data-target="#collapseColumnOptions" data-parent="#accordion">
                <img data-v-32d4f241="" src="/static/images/icons/filter_chevron_down.svg" class="downCarret">
                <img data-v-32d4f241="" src="/static/images/icons/filter_chevron_down.svg" class="upCarret">
              </button>
            </span>
          </div>
          <div class="col-xs-12 p-0 collapse" id="collapseColumnOptions">
            <ul role="menu" v-on:click.stop class="column-options-ul">
              <li class="col-xs-12 column-name mb-0 p-0" v-for="cellVal in headers" :key="cellVal">
                <div class="col-xs-12 p-0 d-flex" :class="{'tooltip-wrapper': mandatoryColumns && mandatoryColumns.includes(cellVal)}">
                  <span class="tooltiptext" v-if="mandatoryColumns && mandatoryColumns.includes(cellVal)">Mandatory column</span>
                  <div class="col-xs-1 p-0 activityTracker-checkbox">
                    <span class="checkbox">
                      <label>
                        <input type="checkbox" :disabled="mandatoryColumns && mandatoryColumns.includes(cellVal)" :value="cellVal" v-model="userSelectableColumns" />
                        <span class="cr">
                          <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                          <!-- <i class="cr-icon glyphicon glyphicon-ok"></i> -->
                        </span>
                      </label>
                    </span>
                  </div>
                  <div class="col-xs-10 pl-8 pr-0 column-options-items-text">
                    <span
                      class="vertical-align-sub select-item"
                      v-bind:class="{
                        'font-bold': userSelectableColumns.indexOf(cellVal) > -1,
                        'font-normal': userSelectableColumns.indexOf(cellVal) === -1
                      }"
                      >{{ translate(cellVal) }}</span
                    >
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- <div class="col-xs-12 p-0" v-if="permissions.includes('RECORDS_WITH_ATTACHMENT')"> -->
            <!-- <div class="col-xs-12 item-divider p-0 cursor-pointer flex-between" @click="filterWithType('attachment')">
              <div class="col-xs-10 p-0 font-properties font-bold pl-13">
                Records With Attachments
              </div>
              <img class="col-xs-2 text-right p-0 image-size" v-if="filterOptions.attachment" src="/static/images/icons/check.svg" />
            </div> -->
            <!-- <div class="col-xs-12 column-options-carret-section p-0 filter-options-outline">
              <div class="filter-options">{{$t('recordType')}}</div>
              <span>
                <button data-toggle="collapse" data-target="#collapseRecordsWithAttachments" data-parent="#accordion">
                  <img data-v-32d4f241="" src="/static/images/icons/filter_chevron_down.svg" class="downCarret">
                  <img data-v-32d4f241="" src="/static/images/icons/filter_chevron_down.svg" class="upCarret">
                </button>
              </span>
            </div>
            <div class="col-xs-12 collapse p-0 record-type" id="collapseRecordsWithAttachments">
              <ul role="menu" v-on:click.stop class="mb-0 p-0">
                <li class="col-xs-12 record-type-item p-0 pt-25 pb-18">
                  <div class="col-xs-12 p-0 d-flex align-center">
                    <div class="col-xs-1 p-0 activityTracker-checkbox">
                      <span class="checkbox">
                        <label>
                          <input type="checkbox" @click="filterWithType('attachment')"/>
                          <span class="cr">
                            <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                          </span>
                        </label>
                      </span>
                    </div>
                    <div class="col-xs-10 pl-8 pr-0">
                      <span>{{$t('withAttachment')}}</span>
                    </div>
                  </div>
                </li>
                <li class="col-xs-12 record-type-item p-0">
                  <div class="col-xs-12 p-0 d-flex align-center">
                    <div class="col-xs-1 p-0 activityTracker-checkbox">
                      <span class="checkbox">
                        <label>
                          <input type="checkbox"/>
                          <span class="cr">
                            <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                          </span>
                        </label>
                      </span>
                    </div>
                    <div class="col-xs-10 pl-8 pr-0">
                      <span>{{$t('withoutAttachment')}}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div> -->
            <!-- <div class="col-xs-12 item-divider p-0 cursor-pointer flex-between" @click="filterWithType('regulatoryAlert')">
              <div class="font-properties font-bold pl-13">
                Affected By Regulatory Alert
              </div>
              <img class="text-right image-size" v-if="filterOptions.regulatoryAlert" src="/static/images/icons/check.svg" />
            </div> -->
          <!-- </div> -->
          <div class="col-xs-12 p-0" v-for="(value, keyValue) in chevronList" :key="keyValue">
            <div
              class="col-xs-12 col-md-12 col-lg-12 item-divider p-0 cursor-pointer filter-options-outline"
              @click="toggleSelection(`collapse${value.replaceAll(' ', '')}`, keyValue)"
              :class="{'hide-field': (value === 'Sub Category' && !filterOptions.categories) ||
              (value === 'Expiration Date' && (permissions.indexOf('EXPIRATION_DATES') === -1)) ||
              (value === 'Country' && (permissions.indexOf('COUNTRY_WISE_FILTER_AND_SEARCH') === -1))
              }"
            >
              <div class="col-xs-10 col-md-10 col-lg-10 p-0 filter-options">
                <a v-if="value === 'Country'"
                  class="font-properties font-bold pl-13"
                  data-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExpireyDate"
                  >{{$t('countryOfOrigin')}}</a>
                <a v-else-if="value === 'Expiration Date'"
                  class="font-properties font-bold pl-13"
                  data-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExpireyDate"
                  >{{$t('expirationDate')}}
                  </a
                >
              </div>
              <div class="col-xs-2 text-right pr-1">
                <a v-if="!selection[keyValue]">
                  <img src="/static/images/icons/filter_chevron_down.svg" class="transform-img">
                </a>
                <a v-else>
                  <img src="/static/images/icons/filter_chevron_down.svg">
                </a>
              </div>
            </div>
            <div
              v-if="['collapseDocumentDate', 'collapsePostedDate', 'collapseApprovalDate', 'collapseDate', 'collapseDateCreated'].includes(`collapse${value.replaceAll(' ', '')}`)"
              class="col-xs-12 col-md-12 col-lg-12 collapse pr-0 item-divider"
              :class="[selection[keyValue] ? 'in' : '', `collapse${value.replaceAll(' ', '')}`]"
            >
              <!-- <div class="col-xs-12 col-md-12 col-lg-12 p-0 date-range"> -->
              <div class="col-xs-12 col-md-12 col-lg-12 p-0 date-range">
                <ul class="pl-0 mt-6">
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isLast7Days', 'commonDates')"
                    v-if="(types.label === 'regWatch' && permissions.includes('REG_WTCH_REG_UPD_LAST_7_DAYS')) || types.label !== 'regWatch'"
                  >
                    <div class="col-xs-10 pl-0 sub-approval" :class="{'font-bold': totalDates.commonDates.isLast7Days}">Last 7 days</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.commonDates.isLast7Days">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isLast30Days', 'commonDates')"
                    v-if="(types.label === 'regWatch' && permissions.includes('REG_WTCH_REG_UPD_LAST_30_DAYS')) || types.label !== 'regWatch'"
                  >
                    <div class="col-xs-10 pl-0 sub-approval"  :class="{'font-bold': totalDates.commonDates.isLast30Days}">Last 30 days</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.commonDates.isLast30Days">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isLastYear', 'commonDates')"
                    v-if="(types.label === 'regWatch' && permissions.includes('REG_WTCH_REG_UPD_LAST_YEAR')) || types.label !== 'regWatch'"
                  >
                    <div class="col-xs-10 pl-0 sub-approval"  :class="{'font-bold': totalDates.commonDates.isLastYear}">Within last year</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.commonDates.isLastYear">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                </ul>
                <filter-date v-if="(types.label === 'regWatch' && permissions.includes('REG_WTCH_REG_UPD_POSTED_DATE_RANGE')) || types.label !== 'regWatch'"
                  :eventType="'commonDates'"
                  @dateRange="setCustomDateRange($event, value, 'commonDates')"
                  :label="types.label"
                  :dateFormat="dateFormat">
                </filter-date>
              </div>
              <!-- </div> -->
            </div>
            <!-- Account types will start here -->
            <div v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseAccountType'"
              class="collapse collapseAccountType col-xs-12 col-md-12 col-lg-12 p-0 item-divider"
              :class="{in: selection[keyValue]}"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 pr-0 date-range">
                <ul class="pl-0">
                  <li
                    class="col-xs-12 p-0 sub-approval"
                    @click="onAccountTypeOrStatusSelection('rep', 'accountType')"
                  >
                    <div class="col-xs-10 pl-0" :class="{'font-bold': filterOptions.accountType === 'rep'}">Rep</div>
                    <a class="col-xs-2 p-0 text-right" v-if="filterOptions.accountType === 'rep'">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0 sub-approval"
                    @click="onAccountTypeOrStatusSelection('commercial', 'accountType')"
                  >
                    <div class="col-xs-10 pl-0" :class="{'font-bold': filterOptions.accountType === 'commercial'}">Commercial</div>
                    <a class="col-xs-2 p-0 text-right" v-if="filterOptions.accountType === 'commercial'">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    v-if="types.label === 'launchpadUsers'"
                    class="col-xs-12 p-0 sub-approval"
                    @click="onAccountTypeOrStatusSelection('repcommercial', 'accountType')"
                  >
                    <div class="col-xs-10 pl-0" :class="{'font-bold': filterOptions.accountType === 'repcommercial'}">Rep/Commercial</div>
                    <a class="col-xs-2 p-0 text-right" v-if="filterOptions.accountType === 'repcommercial'">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Account types will end here -->
            <!-- Confirm status for users will start here -->
            <div v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseConfirmStatus'"
              class="collapse collapseAccountType col-xs-12 col-md-12 col-lg-12 p-0"
              :class="{in: selection[keyValue], 'item-divider': includeDeactivatedUsers, 'mt-7': !includeDeactivatedUsers}"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 pr-0 date-range">
                <ul class="pl-0">
                  <li
                    class="col-xs-12 p-0 sub-approval"
                    @click="onAccountTypeOrStatusSelection('confirmed', 'confirmedType')"
                  >
                    <div class="col-xs-10 pl-0" :class="{'font-bold': filterOptions.confirmedType === 'confirmed'}">Confirmed</div>
                    <a class="col-xs-2 p-0 text-right" v-if="filterOptions.confirmedType === 'confirmed'">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0 font-16"
                    @click="onAccountTypeOrStatusSelection('unconfirmed', 'confirmedType')"
                  >
                    <div class="col-xs-10 pl-0" :class="{'font-bold': filterOptions.confirmedType === 'unconfirmed'}">Unconfirmed</div>
                    <a class="col-xs-2 p-0 text-right" v-if="filterOptions.confirmedType === 'unconfirmed'">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Confirm status for users will end here -->
            <!-- <div v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseUserStatus'"
              class="collapse collapseAccountType col-xs-12 col-md-12 col-lg-12 p-0 mt-7"
            >
            </div> -->
            <!-- Service Expiration will start here -->
            <div v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseServiceExpiration'"
             class="collapse collapseServiceExpiration col-xs-12 col-md-12 col-lg-12 p-0 item-divider"
              :class="{in: selection[keyValue]}"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 date-range">
                <ul class="pl-0 mt-6">
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isExpiringIn30Days', 'serviceExpDates')"
                  >
                    <div class="col-xs-10 pl-0 sub-approval" :class="{'font-bold': totalDates.serviceExpDates.isExpiringIn30Days}">Expiring in 30 days</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.serviceExpDates.isExpiringIn30Days">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isExpiringIn30To45Days', 'serviceExpDates')"
                  >
                    <div class="col-xs-10 pl-0 sub-approval"  :class="{'font-bold': totalDates.serviceExpDates.isExpiringIn30To45Days}">Expiring &gt; 30 days and <br/> &le; 45 days</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.serviceExpDates.isExpiringIn30To45Days">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                </ul>
                <filter-date
                  :eventType="'serviceExpDates'"
                  @dateRange="setCustomDateRange($event, value, 'serviceExpDates')"
                  :label="types.label"
                  :dateFormat="dateFormat">
                </filter-date>
              </div>
            </div>
            <div v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseServicesRegistered'"
              class="collapse collapseServicesRegistered col-xs-12 col-md-12 col-lg-12 p-0"
              :class="{in: selection[keyValue], 'item-divider': includeDeactivatedAccounts}"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 pr-0 date-range">
                <ul class="pl-0 mt-6">
                  <li
                    class="col-xs-12 p-0"
                    v-for="(service, index) in servicesList" :key="index" @click="selectService(service.name)"
                    >
                    <div class="col-xs-10 pl-0 sub-approval" :class="{'font-bold': filterOptions.servicesRegistered.indexOf(service.name) > -1}">{{service.name}}</div>
                    <a class="col-xs-2 p-0 text-right" v-if="filterOptions.servicesRegistered.indexOf(service.name) > -1">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Service Expiration will end here -->
            <!-- Account status/User Status will start here -->
            <div v-if="(`collapse${value.replaceAll(' ', '')}` === 'collapseAccountStatus' && includeDeactivatedAccounts) ||
              (`collapse${value.replaceAll(' ', '')}` === 'collapseUserStatus' && includeDeactivatedUsers)"
              class="collapse col-xs-12 col-md-12 col-lg-12 p-0"
              :class="{in: selection[keyValue], collapseAccountStatus: includeDeactivatedAccounts, collapseUserStatus: includeDeactivatedUsers}"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 date-range pr-0">
                <ul class="pl-0 mt-6">
                  <li
                    class="col-xs-12 p-0"
                    @click="onAccountTypeOrStatusSelection('active', mappedValues[value])"
                    >
                    <div class="col-xs-10 pl-0 sub-approval" :class="{'font-bold': filterOptions[mappedValues[value]] === 'active'}">Active</div>
                    <a class="col-xs-2 p-0 text-right" v-if="filterOptions[mappedValues[value]] === 'active'">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onAccountTypeOrStatusSelection('deactivated', mappedValues[value])"
                    >
                    <div class="col-xs-10 pl-0 sub-approval" :class="{'font-bold': filterOptions[mappedValues[value]] === 'deactivated'}">Deactivated</div>
                    <a class="col-xs-2 p-0 text-right" v-if="filterOptions[mappedValues[value]] === 'deactivated'">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Account status/User Status will end here -->
            <!-- Categories will start here -->
              <div v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseCategory'"
                class="collapse collapseCategory col-xs-12 col-md-12 col-lg-12 mt-10 p-0"
                :class="{in: selection[keyValue]}"
              >
                <div class="form-group">
                  <el-tooltip
                    effect="light"
                    :content="tooltips.category"
                    placement="top"
                    :disabled="!filterOptions.categories"
                    popper-class="br-10 w-250 custom-doc-el-select"
                  >
                  <multiselect
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    open-direction="bottom"
                    :searchable="false"
                    :options="availableCategoriesList.map(category => category.id)"
                    :custom-label="option => availableCategoriesList.find(x => x.id === option).name"
                    v-model="filterOptions.categories"
                    @input="setSubCategoriesList(filterOptions.categories)"
                    placeholder="Select Category"
                  >
                  </multiselect>
                  </el-tooltip>
                </div>
              </div>
            <!-- Categories will end here -->
            <!-- Sub Categories will start here -->
            <div
              v-if="filterOptions.categories && `collapse${value.replaceAll(' ', '')}` === 'collapseSubCategory'"
              class="collapse collapseSubCategory col-xs-12 col-md-12 p-0 col-lg-12 mt-10"
              :class="{in: selection[keyValue]}"
            >
              <div class="col-xs-12 p-0">
                <div class="form-group">
                  <el-tooltip
                    effect="light"
                    :content="tooltips.subCategory"
                    placement="top"
                    :disabled="!filterOptions.subCategories"
                    popper-class="w-250"
                  >
                  <multiselect
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    open-direction="bottom"
                    :searchable="false"
                    :options="availableSubCategoriesList.map(subCategory => subCategory.id)"
                    :custom-label="option => availableSubCategoriesList.find(x => x.id === option).name"
                    v-model="filterOptions.subCategories"
                    @input="setTooltipForSubcategories(filterOptions.subCategories)"
                    placeholder="Select Sub-category"
                  >
                  </multiselect>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <!-- Sub categories will end here -->
            <!-- Countries will start here -->
            <div
                v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseCountry'"
                class="collapse collapseCountry col-xs-12 col-md-12 col-lg-12 multiple-select-zindex p-0"
                :class="{in: selection[keyValue]}"
              >
                <div class="col-xs-12 countries-list">
                  <div class="col-xs-12 p-0 search-container-wraper">
                    <div class="search-container col-xs-12 p-0">
                      <search-box  v-model="countryName"  @getList="filterCountriesList()"></search-box>
                    </div>
                  </div>
                  <div class="col-xs-12 p-0 pt-10 element-scroll-bar" v-if="availableCountriesList.length">
                    <el-scrollbar wrap-style="height: 170px;">
                      <ul v-on:click.stop>
                        <li v-for="country in availableCountriesList" :key="country[types.countryId]">
                          <div class="col-xs-12 p-0 m-0 country-name-checkbox">
                            <div class="col-xs-1 p-0 activityTracker-checkbox">
                              <span class="checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    :value="country[types.countryId]"
                                    v-model="selectedCountryIdList"
                                    @change="setFilteredCountriesList"
                                  />
                                  <span class="cr">
                                    <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                                  </span>
                                </label>
                              </span>
                            </div>
                            <div class="col-xs-10 p-0 pl-8">
                              <span class="vertical-align-sub countries"
                                :class="{
                                  'active-country':
                                    selectedCountryIdList.indexOf(country[types.countryId]) > -1
                                }"
                              >{{country[types.countryName]}}</span>
                            </div>
                          </div>
                        </li>
                      </ul>
                  </el-scrollbar>
                  </div>
                  <div v-else class="col-xs-12 text-center font-16 mt-10">
                    {{ $t('noCountriesFound') }}
                  </div>
                </div>
            </div>
            <!-- Countries will end here -->
            <!-- Effective date will start here -->
            <div v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseEffectiveDate'"
              class="collapse collapseEffectiveDate col-xs-12 col-md-12 col-lg-12 mt-10 p-0"
              :class="{in: selection[keyValue]}"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 p-0 date-range">
                <div class="col-xs-12 col-md-12 col-lg-12 date-range">
                <ul class="pl-0 mt-6">
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isNext30Days', 'effectiveDates',)"
                    v-if="(types.label === 'regWatch' && permissions.includes('REG_WTCH_REG_UPD_NEXT_30_DAYS')) || types.label !== 'regWatch'"
                  >
                    <div class="col-xs-10 pl-0 sub-approval" :class="{'font-bold': totalDates.effectiveDates.isNext30Days}">Next 30 Days</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.effectiveDates.isNext30Days">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isNext6Months', 'effectiveDates')"
                    v-if="(types.label === 'regWatch' && permissions.includes('REG_WTCH_REG_UPD_NEXT_6_MONTHS')) || types.label !== 'regWatch'"
                  >
                    <div class="col-xs-10 pl-0 sub-approval"  :class="{'font-bold': totalDates.effectiveDates.isNext6Months}">Next 6 Months</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.effectiveDates.isNext6Months">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isThisYear', 'effectiveDates')"
                    v-if="(types.label === 'regWatch' && permissions.includes('THIS_YEAR')) || types.label !== 'regWatch'"
                  >
                    <div class="col-xs-10 pl-0 sub-approval"  :class="{'font-bold': totalDates.effectiveDates.isThisYear}">This Year</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.effectiveDates.isThisYear">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isNextYear', 'effectiveDates')"
                    v-if="(types.label === 'regWatch' && permissions.includes('REG_WTCH_REG_UPD_NEXT_YEAR')) || types.label !== 'regWatch'"
                  >
                    <div class="col-xs-10 pl-0 sub-approval"  :class="{'font-bold': totalDates.effectiveDates.isNextYear}">Next Year</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.effectiveDates.isNextYear">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                </ul>
                <filter-date v-if="(types.label === 'regWatch' && permissions.includes('REG_WTCH_REG_UPD_EFF_DATE_RANGE')) || types.label !== 'regWatch'"
                  :eventType="'effectiveDates'"
                  @dateRange="setCustomDateRange($event, value, 'effectiveDates')"
                  :label="types.label"
                  :dateFormat="dateFormat">
                </filter-date>
              </div>
              </div>
            </div>
            <div v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseExpirationDate'"
              class="collapse collapseExpirationDate col-xs-12 col-md-12 col-lg-12 p-0"
              :class="{in: selection[keyValue]}"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 p-0 date-range">
                <ul class="pl-0">
                  <li
                    class="col-xs-12 p-0 d-flex"
                    @click="onDocumentDaysSelection('isThisMonth', 'expirationDates')"
                  >
                    <div class="col-xs-10 pl-0 sub-approval mb-16" :class="{'font-bold': totalDates.expirationDates.isThisMonth}">{{$t('thisMonth')}}</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.expirationDates.isThisMonth">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0 d-flex"
                    @click="onDocumentDaysSelection('isNext3Months', 'expirationDates')"
                  >
                    <div class="col-xs-10 pl-0 sub-approval mb-16"  :class="{'font-bold': totalDates.expirationDates.isNext3Months}">{{$t('next3Months')}}</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.expirationDates.isNext3Months">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0 d-flex"
                    @click="onDocumentDaysSelection('isThisYear', 'expirationDates')"
                  >
                    <div class="col-xs-10 pl-0 sub-approval mb-12"  :class="{'font-bold': totalDates.expirationDates.isThisYear}">{{$t('withInThisYear')}}</div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.expirationDates.isThisYear">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                      />
                    </a>
                  </li>
                </ul>
                <filter-date
                  :eventType="'expirationDates'"
                  @dateRange="setCustomDateRange($event, value, 'expirationDates')"
                  :label="types.label"
                  :dateFormat="dateFormat">
                </filter-date>
              </div>
            </div>
            <!-- Effective date will end here -->
          </div>
        </div>
        <!-- <div class="col-xs-12 text-right clear-option cursor-pointer pr-0" v-if="permissions.includes('CLEAR_ALL')">
          <a
            @click.prevent="clearAll()"
            >Clear All</a
          >
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { cloneDeep, isEqual } from 'lodash';
import moment from 'moment';
import getDateRange from './mixins/dateRangeSelectionMixin';
import FilterDate from './FilterDate.vue';
import SearchBox from './SearchBox.vue';
import EventBus from '../../utils/event-bus';

export default {
  // props: [
  //   'chevronList',
  //   'expectedFilter',
  //   'dateFormat',
  //   'categoriesList',
  //   'subCategoriesList',
  //   'countriesList',
  //   'types',
  //   'permissions',
  // ],

  props: {
    permissions: {
      type: Array,
      default() {
        return [];
      },
    },
    chevronList: {
      type: Object,
    },
    expectedFilter: {
      type: Object,
    },
    dateFormat: {
      type: String,
    },
    categoriesList: {
      type: Array,
      default() {
        return [];
      },
    },
    subCategoriesList: {
      type: Array,
      default() {
        return [];
      },
    },
    countriesList: {
      type: Array,
      default() {
        return [];
      },
    },
    types: {
      type: Object,
    },
    servicesList: {
      type: Array,
      default() {
        return [];
      },
    },
    includeDeactivatedAccounts: {
      type: Boolean,
      default: false,
    },
    includeDeactivatedUsers: {
      type: Boolean,
      default: false,
    },
    isRegWatch: {
      type: Boolean,
      default: false,
    },
    registrationHeader: {
      required: false,
    },
    headers: {
      required: false,
    },
    selectedColumns: {
      required: false,
    },
    mandatoryColumns: {
      required: false,
    },
  },

  mixins: [getDateRange],
  components: {
    FilterDate,
    SearchBox,
  },
  data() {
    return {
      isDateEntered: false,
      headersCopy: '',
      userSelectableColumns: [],
      triggerWatchInitially: false,
      totalDates: {
        commonDates: {
          isLast7Days: false,
          isLast30Days: false,
          isLastYear: false,
        },
        effectiveDates: {
          isNext30Days: false,
          isNext6Months: false,
          isThisYear: false,
          isNextYear: false,
        },
        expirationDates: {
          isThisMonth: false,
          isNext3Months: false,
          isThisYear: false,
        },
        serviceExpDates: {
          isExpiringIn30Days: false,
          isExpiringIn30To45Days: false,
        },
      },
      countryName: '',
      mappedValues: {
        'Document Date': 'dateRange',
        Date: 'dateRange',
        'Date Created': 'dateRange',
        Category: 'categories',
        'Sub Category': 'subCategories',
        'Posted Date': 'dateRange',
        'Effective Date': 'effectiveDates',
        'Expiration Date': 'expirationDates',
        'Approval Date': 'dateRange',
        'Account Type': 'accountType',
        'Service Expiration': 'serviceExpDates',
        'Services Registered': 'servicesRegistered',
        'Account Status': 'accountStatus',
        'User Status': 'userStatus',
        'Confirm Status': 'confirmedType',
      },
      start_approval_date: '',
      end_approval_date: '',
      // isDateRangeSelected: false,
      // showFilterIcon: false,
      collapsed: true,
      availableCategoriesList: [],
      categoryListWithIdAndNames: {},
      availableSubCategoriesList: [],
      subCategoryListWithIdAndNames: {},
      availableCountriesList: [],
      selection: {},
      filterOptions: {},
      selectedCountryIdList: [],
      tooltips: {
        category: '',
        subCategory: '',
        service: '',
      },
    };
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      const returnVal = value.replace(/_/g, ' ').toString();
      return returnVal
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
    },
  },
  watch: {
    selectedColumns: {
      handler() {
        if (this.selectedColumns.length) {
          this.triggerWatchInitially = true;
          this.userSelectableColumns = [...this.selectedColumns];
        }
      },
      immediate: true,
    },
    userSelectableColumns: {
      handler(newVal, oldValue) {
        if (this.userSelectableColumns.length && !this.triggerWatchInitially) {
          if (this.userSelectableColumns.length > 6) {
            this.$nextTick(() => {
              this.userSelectableColumns.splice(6, this.userSelectableColumns.length);
            });
            this.clearNotifcations();
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Limite' : 'Limit',
              text: this.$i18n.locale === 'Portuguese' ? 'Podem ser adicionadas no máximo 6 colunas.' : 'Max 6 columns can be added.',
              group: 'custom-notification',
            });
          }
          if (this.userSelectableColumns.length < 3) {
            const text = this.$i18n.locale === 'Portuguese' ? 'A tabela deve ter no mínimo 3 colunas.' : 'Table should have Min 3 columns.';
            this.$nextTick(() => {
              this.userSelectableColumns = [...oldValue];
            });
            this.clearNotifcations();
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Limite' : 'Limit',
              text,
              group: 'custom-notification',
            });
          }
          this.$emit('setSelectedColumns', this.userSelectableColumns);
        }
        this.triggerWatchInitially = false;
      },
      immediate: true,
    },
    chevronList: {
      handler(value) {
        Object.keys(value).forEach((key) => {
          this.selection[key] = false;
        });
      },
      immediate: true,
    },
    expectedFilter: {
      handler(newValue) {
        this.filterOptions = cloneDeep(newValue);
      },
      immediate: true,
    },
    categoriesList: {
      handler(newValue) {
        if (newValue) {
          this.availableCategoriesList = cloneDeep(this.categoriesList);
          this.categoryListWithIdAndNames = this.getListOfIdsWithNames(
            this.categoriesList,
          );
        }
      },
      immediate: true,
    },
    subCategoriesList: {
      handler(newValue) {
        if (newValue) {
          this.subCategoryListWithIdAndNames = this.getListOfIdsWithNames(
            this.subCategoriesList,
          );
        }
      },
      immediate: true,
    },
    countriesList: {
      handler(newValue) {
        if (newValue) {
          this.availableCountriesList = cloneDeep(this.countriesList);
        }
      },
      immediate: true,
    },
    includeDeactivatedAccounts: {
      handler(newValue) {
        if (!newValue && this.filterOptions.accountStatus) {
          this.filterOptions.accountStatus = '';
          this.checkIsFilterValuesManuallyCleared();
        }
      },
    },
    includeDeactivatedUsers: {
      handler(newValue) {
        if (!newValue && this.filterOptions.userStatus) {
          this.filterOptions.userStatus = '';
          this.checkIsFilterValuesManuallyCleared();
        }
      },
    },
  },
  computed: {
    showFilterIcon() {
      return !(isEqual(this.expectedFilter, this.filterOptions));
    },
  },

  mounted() {
    EventBus.$on('redirectionParams', (params) => {
      if (this.types.label === 'regWatch' || this.types.label === 'marketInsights') {
        if ((this.types.label === 'regWatch' && this.countriesList.some((list) => list.id === params.countryId)) || this.types.label === 'marketInsights') {
          this.selectedCountryIdList = [params.countryId];
        }
        if (params.startDate && params.endDate) {
          this.filterOptions.dateRange.from = moment(params.startDate).format(this.dateFormat);
          this.filterOptions.dateRange.to = moment(params.endDate).format(this.dateFormat);
          EventBus.$emit('setCustomDatesForcommonDates', { startDate: params.startDate, endDate: params.endDate });
        }
        this.setFilteredCountriesList();
      } else if (['launchpadAccounts', 'launchpadUsers'].includes(this.types.label)) {
        this.filterOptions.accountType = params.account_type;
        this.emitFilterOptions();
      }
    });
    // EventBus.$on('updateFilter1', (params) => {
    //   this.$nextTick(() => {
    //     this.totalDates.expirationDates[params] = true;
    //   });
    // });
  },

  beforeDestroy() {
    EventBus.$off('redirectionParams');
  },

  methods: {
    checkForDisability() {
      if (!isEqual(this.selectedColumns, this.userSelectableColumns) || this.isDateEntered || this.totalDates.expirationDates.isThisMonth || this.totalDates.expirationDates.isNext3Months || this.totalDates.expirationDates.isThisYear || this.selectedCountryIdList.length) {
        return false;
      }
      return true;
    },
    convertToStrings(name) {
      switch (name) {
        case 'Accredited by':
          name = 'Accredited_by';
          break;
        case 'Approval date':
          name = 'Approval_date';
          break;
        case 'Archive reason':
          name = 'Archive_reason';
          break;
        case 'Barcode Attachments':
          name = 'Barcode_Attachments';
          break;
        case 'Brand name':
          name = 'Brand_name';
          break;
        case 'Certification URL':
          name = 'Certification_URL';
          break;
        case 'Certification mark':
          name = 'Certification_mark';
          break;
        case 'Certification number':
          name = 'Certification_number';
          break;
        case 'Comments':
          name = 'Comments';
          break;
        case 'Country of origin':
          name = 'Country_of_origin';
          break;
        case 'Description':
          name = 'Description';
          break;
        case 'Expiration':
          name = 'Expiration';
          break;
        case 'Imported Product':
          name = 'Imported_Product';
          break;
        case 'Importer':
          name = 'Importer';
          break;
        case 'Input Status':
          name = 'Input_Status';
          break;
        case 'Managed by':
          name = 'Managed_by';
          break;
        case 'Manufacturer':
          name = 'Manufacturer';
          break;
        case 'Marked input voltage':
          name = 'Marked_input_voltage';
          break;
        case 'Marked input wattage':
          name = 'Marked_input_wattage';
          break;
        case 'Model name':
          name = 'Model_name';
          break;
        case 'Ordinance':
          name = 'Ordinance';
          break;
        case 'Barcode':
          name = 'Barcode';
          break;
        case 'Product Certificate Attachments':
          name = 'Product_Certificate_Attachments';
          break;
        case 'Product category':
          name = 'Product_category';
          break;
        case 'Product class':
          name = 'Product_class';
          break;
        case 'Product name':
          name = 'Product_name';
          break;
        case 'Related records':
          name = 'Related_records';
          break;
        case 'Requester':
          name = 'Requester';
          break;
        case 'Standards':
          name = 'Standards';
          break;
        case 'Status':
          name = 'Status';
          break;
        case 'Test Report Attachments':
          name = 'Test_Report_Attachments';
          break;
        case 'Trade Representative':
          name = 'Trade_Representative';
          break;
        default:
          name = '';
          break;
      }
      return name;
    },
    translate(name) {
      if (this.$i18n.locale === 'Portuguese') {
        const res = this.convertToStrings(name);
        const data = {
          Accredited_by: 'Credenciado por',
          Approval_date: 'Data de Aprovação',
          Archive_reason: 'Razão de Arquivamento',
          Barcode_Attachments: 'Anexos de Código de Barras',
          Brand_name: 'Nome da Marca',
          Certification_URL: 'URL da Certificação',
          Certification_mark: 'Marca da Certificação',
          Certification_number: 'Número da Certificação',
          Comments: 'Comentários',
          Country_of_origin: 'País de Origem',
          Description: 'Descrição',
          Expiration: 'Expiração',
          Imported_Product: 'Produto importado',
          Importer: 'Importador',
          Input_Status: 'Status de Entrada',
          Managed_by: 'Gerenciado Por',
          Manufacturer: 'Fabricante',
          Marked_input_voltage: 'Tensão de Entrada Marcada',
          Marked_input_wattage: 'Potência de Entrada Marcada',
          Model_name: 'Nome do Modelo',
          Ordinance: 'Portaria',
          Barcode: 'Código de Barras',
          Product_Certificate_Attachments: 'Anexos de Certificado de Produto',
          Product_category: 'Categoria do Produto',
          Product_class: 'Classe do Produto',
          Product_name: 'Nome do Produto',
          Related_records: 'Registros Relacionados',
          Requester: 'Solicitante',
          Standards: 'Normas',
          Status: 'Status',
          Test_Report_Attachments: 'Anexos do Relatório de Testes',
          Trade_Representative: 'Representante Comercial',
        };
        return data[res];
      }
      return name;
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    setCustomDateRange(value, key, dateCategory) {
      if (value.from !== '' && value.to !== '') {
        this.isDateEntered = true;
      }
      const filterKey = this.mappedValues[key];
      this.filterOptions[filterKey] = value;
      this.setDaysSelected('', dateCategory);
      this.emitFilterOptions();
    },

    onAccountTypeOrStatusSelection(value, key) {
      if (this.filterOptions[key] === value) this.filterOptions[key] = '';
      else this.filterOptions[key] = value;
      this.emitFilterOptions();
    },

    selectService(service) {
      const index = this.filterOptions.servicesRegistered.indexOf(service);
      if (index > -1) this.filterOptions.servicesRegistered.splice(index, 1);
      else this.filterOptions.servicesRegistered.push(service);
      this.emitFilterOptions();
    },

    filterWithType(type) {
      if (type === 'attachment') {
        this.filterOptions.attachment = !this.filterOptions.attachment;
      }
      this.emitFilterOptions();
    },

    setSubCategoriesList(categoryId) {
      this.filterOptions.subCategories = '';
      this.tooltips = {
        ...this.tooltips,
        category: this.categoryListWithIdAndNames[categoryId],
      };
      this.availableSubCategoriesList = this.subCategoriesList.filter(
        (sub) => sub.category_id === categoryId,
      );
      this.emitFilterOptions();
    },
    setTooltipForSubcategories(categoryId) {
      this.tooltips = {
        ...this.tooltips,
        subCategory: this.subCategoryListWithIdAndNames[categoryId],
      };
      this.emitFilterOptions();
    },

    getListOfIdsWithNames(target) {
      return target.reduce((acc, category) => {
        acc[category.id] = category.name;
        return acc;
      }, {});
    },

    onDocumentDaysSelection(daysSelected, dateCategory) {
      this.setDaysSelected(daysSelected, dateCategory);
      if (this.totalDates[dateCategory][daysSelected]) {
        EventBus.$emit(`normalDatesSelected${dateCategory}`);
        this.getStartTimeAndEndTime(daysSelected, dateCategory);
      } else {
        const filterKey = dateCategory === 'commonDates' ? 'dateRange' : dateCategory;
        this.clearDateRangeInFilter(filterKey);
      }
    },

    clearDateRangeInFilter(field) {
      this.filterOptions[field] = {};
      this.emitFilterOptions();
    },

    getStartTimeAndEndTime(daysSelected, dateCategory) {
      const key = dateCategory === 'commonDates' ? 'dateRange' : dateCategory;
      const dateRange = this.getDateRange(daysSelected, this.dateFormat, this.types.label);
      this.filterOptions[key].from = dateRange.startDate;
      this.filterOptions[key].to = dateRange.endDate;
      this.emitFilterOptions();
    },

    clearDateRange() {
      this.start_approval_date = '';
      this.end_approval_date = '';
    },

    setDaysSelected(daysSelected = '', dateCategory) {
      Object.keys(this.totalDates[dateCategory]).forEach((key) => {
        if (daysSelected) {
          this.totalDates[dateCategory][key] = key === daysSelected ? !this.totalDates[dateCategory][key] : false;
        } else this.totalDates[dateCategory][key] = false;
      });
    },

    toggleSelection(filterCSS, flag) {
      this.selection = { ...this.selection, [flag]: !this.selection[flag] };
      // this.filterOptions.categories = 'test';
      if ($(`.${filterCSS}`).hasClass('in')) {
        $(`.${filterCSS}`).removeClass('in');
      } else {
        $(`.${filterCSS}`).addClass('in');
      }
    },

    showHideFilter(isExpanded = false) {
      this.collapsed = !this.collapsed;
      // $('.in,.open').removeClass('in open');
      if (!isExpanded) {
        Object.keys(this.chevronList).forEach((key) => {
          const resultKey = this.mappedValues[this.chevronList[key]];
          if (['isDateChevron', 'isEffectiveDateChevron', 'isExpiryDateChevron', 'isServiceExpChevron'].includes(key)) this.selection[key] = !!(this.filterOptions[resultKey].from && this.filterOptions[resultKey].to);
          else if (key === 'isCategoryChevron') this.selection[key] = !!this.filterOptions[resultKey];
          else if (key === 'isSubCategoryChevron') this.selection[key] = !!this.filterOptions[resultKey];
          else if (key === 'isCountryChevron') this.selection[key] = !!this.selectedCountryIdList.length;
          else if (this.types.label === 'launchpadAccounts') {
            if (key === 'isAccountTypeChevron') this.selection[key] = !!this.filterOptions[resultKey];
            else if (key === 'isServicesChevron') this.selection[key] = !!this.filterOptions[resultKey].length;
            else if (key === 'isAccountStatusChevron') this.selection[key] = !!this.filterOptions[resultKey];
          } else if (this.types.label === 'launchpadUsers') {
            if (key === 'isAccountTypeChevron') this.selection[key] = !!this.filterOptions[resultKey];
            else if (key === 'isUserStatusChevron') this.selection[key] = !!this.filterOptions[resultKey];
            else if (key === 'isConfirmChevron') this.selection[key] = !!this.filterOptions[resultKey];
          }
        });
        /* Remove country name if present when no country selected */
        if (!this.selection.isCountryChevron && this.countryName) {
          this.availableCountriesList = cloneDeep(this.countriesList);
          this.countryName = '';
        }
      }
    },

    /* Market Insights countries selcetion */
    filterCountriesList() {
      const searchWord = this.countryName.toLowerCase();
      this.availableCountriesList = this.countriesList
        .filter((country) => country[this.types.countryName].toLowerCase().includes(searchWord));
    },

    setFilteredCountriesList() {
      this.filterOptions.countriesList = cloneDeep(this.selectedCountryIdList);
      this.emitFilterOptions();
    },

    setAllChevrons() {
      Object.keys(this.selection).forEach((key) => {
        this.selection[key] = false;
      });
    },

    clearAll() {
      $('#collapseColumnOptions').collapse('hide');
      this.userSelectableColumns = [...this.selectedColumns];
      EventBus.$emit('clearAllCustomDates');
      this.countryName = '';
      this.availableCountriesList = cloneDeep(this.countriesList);
      this.setAllChevrons();
      this.setDefaultValuesToAllDates();
      this.selectedCountryIdList = [];
      if (!(isEqual(this.expectedFilter, this.filterOptions))) {
        this.filterOptions = cloneDeep(this.expectedFilter);
        this.emitFilterOptions(false);
      }
      this.isDateEntered = false;
    },
    setFilterOptions() {
      $('#collapseColumnOptions').collapse('hide');
    },

    setDefaultValuesToAllDates() {
      this.totalDates = {
        commonDates: {
          isLast7Days: false,
          isLast30Days: false,
          isLastYear: false,
        },
        effectiveDates: {
          isNext30Days: false,
          isNext6Months: false,
          isThisYear: false,
          isNextYear: false,
        },
        expirationDates: {
          isThisMonth: false,
          isNext3Months: false,
          isThisYear: false,
        },
        serviceExpDates: {
          isExpiringIn30Days: false,
          isExpiringIn30To45Days: false,
        },
      };
    },

    checkIsFilterValuesManuallyCleared() {
      const ref = cloneDeep(this.expectedFilter);
      const refForFilter = cloneDeep(this.filterOptions);
      delete ref.isFilterSelected;
      delete refForFilter.isFilterSelected;
      this.filterOptions.isFilterSelected = !(isEqual(ref, refForFilter));
    },

    emitFilterOptions(clearAll = true) {
      this.filterOptions.isFilterSelected = clearAll;
      this.$emit('setFilter', this.filterOptions);
      if (clearAll) {
        this.checkIsFilterValuesManuallyCleared();
      }
    },
  },
};
</script>

<style scoped>
.mb-16{
  margin-bottom: 16px;
}
.mb-12{
  margin-bottom: 12px;
}
.pt-25{
  padding-top: 25px;
}
.pl-8{
  padding-left: 8px;
}
.pb-18 {
  padding-bottom: 18px;
}
.filter-card-header {
  background: #FFFFFF;
  box-shadow: 4px 4px 10px rgb(0 0 0 / 10%);
}
.column-options-carret-section{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.column-options-carret-section button{
  background-color: transparent !important;
  padding: 0px;
  border: none;
}
.column-options-carret-section span button[aria-expanded="true"] img.downCarret{
  display: none;
}
.column-options-carret-section span button[aria-expanded="true"] img.upCarret{
  display: inline-block;
}
.column-options-carret-section span button img.downCarret {
  display: inline-block;
  transform: rotate(180deg);
}
.column-options-carret-section span button img.upCarret{
  display: none;
}
.reset-apply-buttons{
  padding: 0px 32px 33px 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.reset-link,
.reset-link:hover,
.reset-link:focus{
  padding: 0px;
  border:none;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: #01518a !important;
  background-color: transparent;
}
.apply-btn,
.apply-btn:focus,
.apply-btn:hover{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  background-color: #01518A;
  border: none;
  cursor: pointer;
  color: #ffffff;
  border-radius: 5px;
  padding: 10px 33px 9px 32px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
}
.filter-options,
.filter-options a{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
}
.filter-options-outline {
  padding: 24px 24px 0px 24px;
}
ul li{
  list-style-type: none;
}
.column-options-ul{
  padding: 0px 36px 0px 37px;
  margin: 0px;
}
.column-options-ul li:last-child,
.record-type ul li:last-child{
  padding-bottom: 16px;
}
.column-name{
  padding-top: 18px;
  margin: 0px;
}
.vertical-align-sub{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 25px;
  color: #333333;
}
.column-options-items-text{
  font-size: 16px;
  line-height: 25px !important;
}
.record-type-item{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  padding-left: 28px;
}
/* .compliance_tracker_filter {
  width: 16px;
  height: 18px;
} */
.reg-filter {
  position: absolute;
  z-index: 3;
  left: 15px !important;
  top: 2px;
  margin-left: -20px;
}
.records-filter{
  margin: 12px 8px 12px 12px;
}
.chevron-right{
  padding-left: 0px;
  margin-right: 12px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.registration-header-reg-filter {
  /* display: flex;
  justify-content: flex-end; */
  position: absolute;
  z-index: 3;
  left: 15px !important;
  top: -9px;
  margin-left: -30px;
}

.mt-7 {
  margin-top: 7px;
}

.smart-docs {
  top: unset;
  margin-top: 45px;
}
#activityFilter {
  height: 52px;
  width: 50px;
  margin-left: 5px;
}

/* #registration-header-activityFilter {
  height: 34px;
} */

.reg-dropdown {
  padding: 0px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  border-radius: 0px 4px 4px 0px;
  /* background: #ffffff;
  -webkit-box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  border-radius: 0px 4px 4px 0px; */
}

.registration-header-reg-dropdown {
  padding: 0px 28px 5px 0px;
}

.reg-dropdown.reg-watch {
  height: 56px;
  width: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pl-6 {
  padding-left: 6px;
}
.filter-ul {
  left: 5px!important;
  padding: 16px 16px 16px 24px;
  width: 375px;
  display: block;
  background: #ffffff;
}
.registration-header-filter-ul {
  position: relative;
  margin-right: 10px !important;
  padding: 0px;
  width: 296px;
  display: block;
  background: #ffffff;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
}
.filter-wrapper {
  padding-bottom: 44px;
  overflow: auto;
  height: 376px;
}

/* .filter-icon {
  padding-right: 8px;
} */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  /* border-radius: 20px; */
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
::-webkit-scrollbar-thumb:hover {
  background: #D9D9D9;;
}
.dropdown-menu-left {
  right: auto;
  left: 0px;
  top: -4px;
  margin: 6px 0 0;
}
.h-417 {
  height: 417px;
}
/* .item-divider {
  border-bottom: 1px solid #d3d6d9;
  padding-bottom: 7px;
  margin-top: 6px;
} */

.data-divider {
  border-bottom: 1px solid #d3d6d9;
  margin-top: 7px;
}

.collapseDocumentDate.in {
  border-bottom: 1px solid #d3d6d9;
  padding-bottom: 10px;
}

.mt-6 {
  margin-top: 6px;
}
.mt-24 {
  margin-top: 24px;
}
.pt-3 {
  padding-top: 3px;
}
.filter-text{
  padding: 0px 0px 0px 18px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  /* line-height: 33px; */
  color: #333333;
}
.filter-card-outline {
  display: inline-flex;
  padding: 29px 24px 24px 24px;
}
/* .font-properties {
  padding: 0px 0px 0px 18px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 33px;
  color: #333333;
} */
.sub-approval {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.clear-option a {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #0b3c61;
}

.countries-list ul,
.date-range ul {
  list-style-type: none;
  padding: 0;
  margin: 16px 0px 0px 32px;
  z-index: 1;
  border-radius: 10px;
  border: none;
  max-height: 200px;
}
.date-range ul li{
  /* margin-left: 32px; */
  /* margin-top: 18px; */
  padding: 0px;
}
.countries-list ul li .country-name-checkbox{
  padding-top: 18px;
  display: flex;
  /* align-items: center; */
}

/* .countries-list ul li {
  color: rgba(0, 0, 0, 0.7);
  padding: 5px 5px 0px 0px;
  font-size: 16px;
} */
.flex-wraper {
  display: flex;
}
.count {
  position: absolute;
  left: 27px;
  top: 5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  line-height: 16px;
  font-size: 10px;
  text-align: center;
  cursor: pointer;
  color: white;
  background: #4c9e45;
}

.registration-header-count {
  position: absolute;
  right: 16px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  line-height: 16px;
  font-size: 10px;
  text-align: center;
  cursor: pointer;
  color: white;
  background: #4c9e45;
}

.reg-watch .count {
  left: 40%;
  top: 22%;
}

.countries-list {
  box-sizing: border-box;
  border-radius: 4px;
  height: 250px;
  padding: 24px 35px 0px 24px;
}
.date-range li a{
  margin-right: 24px;
}
.image-size {
  width: 18px;
  height: 18px;
}
.image-small-size {
  width: 12px;
  height: 12px;
}
.mb-13 {
  margin-bottom: 13px;
}
.mr-8 {
  margin-right: 8px;
}

.pr-1 {
  padding-right: 1px;
}

/* .search-container-wraper {
  padding-right: 11px;
} */
.start-to-end {
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.7);
  padding: 5px 8px;
  display: inline;
}
.search-box {
  padding: 17px 72px 17px 20px;
}

.vertical-line {
  top: 7px;
  right: 35px;
  position: absolute;
  border-left: 1px solid #dfe1e5;
  height: 65%;
}

.search-icon {
  top: 7px;
  position: absolute;
  right: 10px;
}
.select-check {
  height: 11px;
  width: 11px;
  position: absolute;
  left: 1px;
  top: 1px
}
.activityTracker-checkbox > .checkbox .cr {
  border: 1px solid #01518a;
  width: 16px;
  height: 16px;
}
.activityTracker-checkbox > .checkbox label input[type="checkbox"]:checked + .cr {
    background-color: #0B3C61;
  }
.active-country {
  font-weight: 600;
}
/*
.countries {
  font-size: 12px;
  line-height: 23px;
  color: #3E3E3E;
} */
.pt-10 {
  padding-top: 10px;
}
.pb-8 {
  padding-bottom: 8px;
}
.element-scroll-bar >>> .el-scrollbar__wrap {
  overflow: auto;
  margin-right: -23px !important;
  margin-bottom: -4px !important;
}

.element-scroll-bar >>> .el-scrollbar__bar.is-horizontal {
  display: none;
}

.vertical-align-bottom {
  vertical-align: bottom;
}

.font-300 {
  font-weight: 300;
}

.vertical-align-top {
  vertical-align: text-top;
}

.chevron-image {
  width: 12px;
  height: 12px;
}

.left-transform {
  transform: rotate(-180deg);
}

.transform-img {
  transform: rotate(180deg);
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.hide-field {
  display: none;
}

.reg-filter.reg-watch {
  top: 0px;
}

.reg-watch .dropdown-menu-left {
  top: -6px;
}

.reg-dropdown.reg-watch {
  height: 56px;
  width: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reg-watch .count {
  left: 40%;
  top: 22%;
}
</style>
